export const capitalizeFirstLetter = (s: string) =>
  s.charAt(0).toUpperCase() + s.slice(1);

export const lowercaseFirstLetter = (s: string) =>
  s.charAt(0).toLowerCase() + s.slice(1);

export const transformName = (inputName: string, formType?: string) =>
  `${formType}${capitalizeFirstLetter(inputName)}`;
